module.exports = __webpack_public_path__ + "static/media/johnstown.4223dee2.png";